import { render, staticRenderFns } from "./QuickRepliesBar.vue?vue&type=template&id=5834ca37"
import script from "./QuickRepliesBar.vue?vue&type=script&lang=js"
export * from "./QuickRepliesBar.vue?vue&type=script&lang=js"
import style0 from "./QuickRepliesBar.vue?vue&type=style&index=0&id=5834ca37&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports